<template>
  <div class="content">
    <div class="title-text">
      <p class="title">Name and Email</p>
    </div>
    <div class="content-body">
      <div class="edit-profile-card">
        <div class="card-content">
          <div class="inputs">
            <div class="first-name">
              <label>
                <span class="label">First Name</span>
                <input
                  v-model="first_name"
                  type="text"
                  placeholder="Please enter your first name"
                />
              </label>
            </div>
            <div class="last-name">
              <label>
                <span class="label">Last Name</span>
                <input
                  v-model="last_name"
                  type="text"
                  placeholder="Please enter your last name"
                />
              </label>
            </div>
            <div class="email-input">
              <label>
                <span class="label">Email Address</span>
                <input
                  v-model="email"
                  type="text"
                  placeholder="Please enter your email"
                />
              </label>
            </div>
          </div>
          <button @click="updateProfile" class="button-default">
            <span>Update Profile</span>
          </button>
        </div>
      </div>
      <div v-if="showResetEmailModal" class="modal">
        <div class="background-overlay"></div>
        <div class="verify-modal">
          <div @click="showResetEmailModal = false" class="modal-close">
            <CloseIcon />
            <span class="close-text">ESC</span>
          </div>
          <div class="modal-content">
            <span class="lets-start-heading">Check your email</span>
            <span class="description">
              Enter the code we sent to
            </span>
            <span class="user-email-text">
              {{ email }}
            </span>
            <CodeVerificationInputs @code="codeInput" />
            <button
              @click="verifyEmailToken"
              class="button-default continue-button"
            >
              Verify and Continue
            </button>
            <span class="no-code-text">Didn't receive code?</span>
            <button @click="requestNewEmailCode" class="button-text">
              <span>Request again</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <SnackBar />
  </div>
</template>

<script>
import CloseIcon from "../../../../public/img/icons/close.svg";
import {
  M_UPDATE_EMAIL,
  M_UPDATE_EMAIL_REQUEST,
  M_UPDATE_NAME,
} from "@/graphql";
import "@/assets/scss/custom/vendors-extensions/_sweetalert.scss";
import "@/assets/scss/custom/vendors-extensions/_braintree.scss";
import CodeVerificationInputs from "@/components/Custom/CodeVerificationInputs";
import SnackBar from "@/components/Custom/SnackBar";
export default {
  name: "UserSettings",
  components: {
    CloseIcon,
    CodeVerificationInputs,
    SnackBar,
  },
  data() {
    return {
      showResetEmailModal: false,
      domains: {},
      first_name: null,
      last_name: null,
      email: null,
      email_token: null,
    };
  },
  async created() {
    this.first_name = this.user.first_name;
    this.last_name = this.user.last_name;
    this.email = this.user.email;
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    async updateProfile() {
      try {
        await this.$apollo.mutate({
          mutation: M_UPDATE_NAME,
          variables: {
            id: this.user.id,
            first_name: this.first_name,
            last_name: this.last_name,
          },
        });
        this.$store.commit("setName", {
          first_name: this.first_name,
          last_name: this.last_name,
        });
        if (this.email && this.email !== this.user.email) {
          const result = await this.$apollo.mutate({
            client: "localClient",
            mutation: M_UPDATE_EMAIL_REQUEST,
            variables: {
              email: this.email,
            },
          });
          if (result.data.update_email_request.success) {
            this.showResetEmailModal = true;
          } else {
            await this.$store.dispatch("snack", {
              type: "error",
              text: `Oops! Update email request failed`,
            });
          }
        }
        await this.$store.dispatch("snack", {
          text: "Success! Your profile details have been saved.",
        });
      } catch (e) {
        await this.$store.dispatch("snack", {
          type: "error",
          text: `Oops! ${e.message.replace("GraphQL error: ", "")}`,
        });
      }
    },
    async verifyEmailToken() {
      try {
        const result = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_UPDATE_EMAIL,
          variables: {
            email: this.email,
            email_token: `${this.email_token}`,
          },
        });
        console.log(result);
        if (result.data.update_email.success) {
          this.showResetEmailModal = false;
          this.$store.commit("setEmail", this.email);
          await this.$store.dispatch("snack", {
            text: "Success! Your email has been updated.",
          });
        } else {
          await this.$store.dispatch("snack", {
            type: "error",
            text: `Oops! Incorrect code`,
          });
        }
      } catch (e) {
        await this.$store.dispatch("snack", {
          type: "error",
          text: `Oops! ${e.message.replace("GraphQL error: ", "")}`,
        });
      }
    },
    async requestNewEmailCode() {
      try {
        const result = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_UPDATE_EMAIL_REQUEST,
          variables: {
            email: this.email,
          },
        });
        if (result.data.update_email_request.success) {
          await this.$store.dispatch("snack", {
            text: "Success! New email and code has been sent.",
          });
        } else {
          await this.$store.dispatch("snack", {
            type: "error",
            text: `Oops! Failed to send new email and code.`,
          });
        }
      } catch (e) {
        await this.$store.dispatch("snack", {
          type: "error",
          text: `Oops! ${e.message.replace("GraphQL error: ", "")}`,
        });
      }
    },
    async codeInput(val) {
      const code = val.join("");
      if (code.length === 6) {
        this.email_token = code;
      } else {
        this.email_token = null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
//@import "../../../assets/scss/custom/components/button/buttons";
//@import "../../../assets/scss/custom/globals/colors";
//@import "../../../assets/scss/custom/globals/fonts";
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  .verify-modal {
    padding: 60px 184px;
    z-index: 98;
    background: linear-gradient(
      241.25deg,
      rgba(41, 39, 85, 0.45) 4.4%,
      rgba(41, 39, 84, 0.85) 61.77%,
      rgba(27, 24, 66, 0.45) 119.94%
    );
    //box-shadow: 0px 51px 69px rgba(23, 18, 43, 0.585739);
    backdrop-filter: blur(23px);
    /* Note: backdrop-filter has minimal browser support */
    border-radius: 10px;
    .modal-close {
      cursor: pointer;
      position: absolute;
      top: 18px;
      right: 18px;
      display: flex;
      flex-direction: column;
      &:hover {
        svg {
          path {
            fill: white;
          }
        }
        .close-text {
          color: white;
        }
      }
      svg {
        width: 24px;
        path {
          fill: #8786ab;
        }
      }
      .close-text {
        font-weight: 600;
        font-size: 8px;
        line-height: 10px;
        text-align: center;
        text-transform: uppercase;
        /* Text/type2 */
        color: $text-type-2;
      }
    }
    .modal-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      .lets-start-heading {
        margin-top: 30px;
        font-weight: bold;
        font-size: 30px;
        line-height: 37px;
        /* White */
        color: white;
        mix-blend-mode: normal;
        opacity: 0.9;
      }
      .description {
        margin-top: 30px;
        /* 16/Regular */
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        /* Text/type0 */
        color: $text-type-0;
      }
      .user-email-text {
        margin-top: 6px;
        /* 16/Regular */
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        /* White */
        color: white;
      }
      .inputs {
        margin-top: 36px;
      }
      .continue-button {
        margin-top: 36px;
        padding: 9px 56px;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
      }
      .no-code-text {
        margin-top: 30px;
        /* 16/Regular */
        font-size: 16px;
        line-height: 24px;
        /* Text/type0 */
        color: $text-type-0;
      }
      .button-text {
        margin-top: 10px;
      }
    }
  }
  .background-overlay {
    z-index: 97;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: unset;
    /* Purple-dark */
    background: $purple-dark;
    opacity: 0.9;
    webkit-backdrop-filter: blur(10px) !important;
    backdrop-filter: blur(10px) !important;
  }
}
.edit-profile-card {
  padding: 0 24px 24px;
  /* BG/type2 */
  background: $bg-type-2;
  /* Shadow */
  box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);
  border-radius: 10px;
  .card-top {
    .card-title {
      /* 18/SemiBold */
      font-weight: 600;
      font-size: 18px;
      line-height: 30px;
      /* White */
      color: white;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
    .card-text {
      margin: 0;
      font-size: 14px;
      line-height: 24px;
      /* Text/type0 */
      color: $text-type-0;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
  }
  .card-content {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .inputs {
      margin-top: 24px;
      width: 100%;
      //display: flex;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      gap: 18px 32px;
      grid-template-areas:
        "firstname lastname"
        "email email";

      .first-name {
        grid-area: firstname;
      }

      .last-name {
        grid-area: lastname;
      }

      .email-input {
        grid-area: email;
      }

      label {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        .label {
          margin-left: 11px;
          width: 100%;
          /* 12/Bold */
          font-weight: bold;
          font-size: 12px;
          line-height: 15px;
          /* Text/type1 */
          color: $text-type-1;
        }
        input {
          margin-top: 6px;
          padding: 13px 11px;
          //width: 100%;
          flex: 1;
          /* Purple-dark */
          background: $purple-dark;
          /* Purple-stroke */
          border: 1px solid $purple-stroke;
          box-sizing: border-box;
          border-radius: 5px;
          outline: none;
          //border: none;
          color: $text-type-0;
          /* 14/Regular */
          font-size: 14px;
          line-height: 17px;
          &:focus {
            outline: none;
            //border: 1px solid $purple;
          }
          &::placeholder {
            color: $text-type-2;
            /* 14/Regular */
            font-size: 14px;
            line-height: 17px;
          }
        }
      }
    }
    button {
      margin-top: 18px;
      padding: 9px 30px;
      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }
  }
}
@keyframes bounce {
  50% {
    transform: scale(1.2);
  }
  75% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
@media (max-width: 600px) {
  .inputs {
    display: flex !important;
    flex-direction: column;
  }
}
</style>
